// The smart sidebar's state: WHICH link is open beside the app, and the question it came from
// (busy-my-web#397 part b — see lib/linkSidebar.js for what this is and is not).
//
// One link at a time: opening another replaces it, exactly as a new tab replaces the reader's
// attention. Closing it hands the rail back to whatever it was showing (SidePanel/index.vue).

import { linkSidebarModel } from '@/lib/linkSidebar'
import { searchQueryFor } from '@/lib/chatTurn'

export const state = {
  link: null,
  question: '',
  openedAt: null,
}

export const getters = {
  link: s => s.link,
  active: s => !!s.link,
  /** The panel's model — what lib/linkSidebar.js makes of the link, or null when none is open. */
  model: s => linkSidebarModel(s.link, s.question),
  /** Is the open link ticked onto the Work-board? Read off the board itself, by the link's id. */
  kept: (s, g, rs, rootGetters) => !!s.link?.id && (rootGetters['workboard/ids'] || []).includes(s.link.id),
}

export const actions = {
  /** A link has left for another tab — brief it on the rail. `{ link, question }`. */
  open({ commit }, payload) {
    const link = payload?.link || payload
    if (!link?.url) return
    commit('SET_LINK', { link, question: payload?.question || '' })
    // A rail the user had folded away is brought back for it — the same call the research store
    // makes when a search's sources land; the panel is what the link left the app FOR.
    commit('sidepanel/SHOW_SIDE_PANEL', null, { root: true })
  },
  close({ commit }) { commit('SET_LINK', null) },

  /** Keep the page on the Work-board (or take it off) — the board's own toggle, same item. */
  keep({ state: s, dispatch }) {
    if (!s.link?.id) return
    return dispatch('workboard/toggle', s.link, { root: true })
  },

  /** Ask the web about this page, in the conversation the link came from — a new web-search turn. */
  searchHere({ state: s, dispatch }) {
    if (!s.link?.url) return
    return dispatch('research/start', { query: searchQueryFor(s.link) }, { root: true })
  },
}

export const mutations = {
  SET_LINK(s, payload) {
    s.link = payload?.link || null
    s.question = payload?.question || ''
    s.openedAt = payload ? Date.now() : null
  },
}
